module.exports = __webpack_public_path__ + "static/media/building.51b6b72b.svg";